export default __webpack_public_path__ + "static/media/bg_image.3ac8fb53.jpg";